export default {
	factoryList: [],
	packageList: [],
	vehicleList: [],
	productConfig: [],
	transportMatrix: [],
    transportStructure: [],
	objFactoryEdit: [],
	runSave: false,
	ObjPackageEdit: [],
	objPackageEditProducts: [],
	objPackageAdd: [],
	objPackageAddProducts: [],
	objVehicleEdit: [],
	objVehicleEditSelectedPackages: [],
	objVehicleEditPackages: [],
	objVehicleEditMatrix: [],
	objVehicleAddSelectedPackages: [],
	objVehicleAddMatrix: [],
	packagesLoaded: false,
	vehiclesLoaded: false
}
